import { makeStyles } from '@material-ui/core/styles';
import { styled } from '@mui/material/styles';
import { Typography } from '@mui/material';

export const useFundStyles = makeStyles((theme) => ({
  allocationBox: {
    display: 'flex',
    alignItems: 'center',
    padding: '30px',
    borderRadius: '6px',
    [theme.breakpoints.down('md')]: {
      padding: '5px',
    },
  },
  allocationText: {
    display: 'inline-block',
    padding: '4px 8px',
    borderRadius: '10px',
    minWidth: '117px',
    textAlign: 'center',
    backgroundColor: theme.palette.secondary.main,
    '&.disabled': {
      backgroundColor: '#e7e7e2',
    },
    '&.error': {
      backgroundColor: '#FFCCCC',
    },
  },
}));

export const AllocationLabelTypography = styled(Typography)(({ theme }) => ({
  fontSize: 22,
  fontWeight: 600,
  [theme.breakpoints.down('md')]: {
    fontSize: 16,
    fontWeight: 600,
  },
}));

export const AllocationTypography = styled(Typography)(({ theme }) => ({
  fontSize: 20,
  fontWeight: 600,
  [theme.breakpoints.down('sm')]: {
    fontSize: 14,
    fontWeight: 600,
  },
}));

export const MessageTypography = styled(Typography)({
  fontSize: 16,
  fontWeight: 600,
  '&&': {
    color: '#AB2B28',
  },
});
